
import Note2 from "../../../assets/duotone/Note2.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Note2Icon({ className, dataTestid = "Note2Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Note2 data-testid={dataTestid} className={classes} {...rest} />
  );
}
